/*
 * Mobiel menu.
 *
 * Elk niveau is een paneel dat inschuift, tot en met de groepen. Eén vorm voor
 * één gedrag: een rij met chevron opent een paneel, een rij zonder chevron
 * navigeert. De terugknop loopt één niveau terug, niet meteen naar boven.
 *
 * Panelen heten p1, p2, ... en een groep daarbinnen p1-<blok-id>. De ouder is
 * dus het stuk voor de laatste streep; is dat er niet, dan is de ouder niveau 1.
 */
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.root = this.querySelector("[data-mobile-menu-root]");
    this.flag = this.querySelector("[data-mobile-menu-flag]");
    this.back = this.querySelector("[data-mobile-menu-back]");
    /* Niet this.title: dat is de ingebouwde tooltip-eigenschap van elk
       HTML-element, die een toegewezen element stilletjes naar tekst omzet. */
    this.titleEl = this.querySelector("[data-mobile-menu-title]");
    this.panels = new Map();
    this.querySelectorAll("[data-mobile-menu-panel]").forEach((p) => {
      this.panels.set(p.dataset.mobileMenuPanel, p);
    });
    this.stack = [];
  }

  connectedCallback() {
    this.addEventListener("click", (event) => {
      const opener = event.target.closest("[data-mobile-menu-open]");
      if (opener && this.contains(opener)) {
        event.preventDefault();
        this.go(opener.dataset.mobileMenuOpen, opener);
        return;
      }

      const back = event.target.closest("[data-mobile-menu-back]");
      if (back && this.contains(back)) {
        event.preventDefault();
        this.goBack();
      }
    });
  }

  go(id, trigger) {
    const panel = this.panels.get(id);
    if (!panel) return;

    this.hideCurrent();
    panel.hidden = false;
    this.animate(panel, "vooruit");
    this.stack.push({ id, trigger: trigger || null });
    this.update();
    this.scrollTop();
    if (this.back) this.back.focus();
  }

  goBack() {
    const vorige = this.stack.pop();
    if (vorige) {
      const panel = this.panels.get(vorige.id);
      if (panel) panel.hidden = true;
    }

    const huidig = this.stack[this.stack.length - 1];
    if (huidig) {
      const panel = this.panels.get(huidig.id);
      if (panel) {
        panel.hidden = false;
        this.animate(panel, "terug");
      }
    } else {
      this.root.hidden = false;
      this.animate(this.root, "terug");
    }

    this.update();
    this.scrollTop();

    /* Focus terug op de rij waarmee je dit paneel opende. */
    if (vorige && vorige.trigger) vorige.trigger.focus();
  }

  /* Een paneel schuift in vanaf de kant waar je vandaan komt, zodat de richting
     van de beweging vertelt of je dieper gaat of terug. */
  animate(el, richting) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    el.classList.remove("slide-vooruit", "slide-terug");
    void el.offsetWidth;
    el.classList.add(richting === "terug" ? "slide-terug" : "slide-vooruit");
  }

  hideCurrent() {
    const huidig = this.stack[this.stack.length - 1];
    if (huidig) {
      const panel = this.panels.get(huidig.id);
      if (panel) panel.hidden = true;
    } else {
      this.root.hidden = true;
    }
  }

  /* De taalkeuze hoort bij niveau 1; dieper nemen de terugknop en de titel de
     balk over. De titel staat in de balk en niet boven de links, zodat de lijst
     bij elke stap op dezelfde hoogte begint. */
  update() {
    const huidig = this.stack[this.stack.length - 1];
    const diep = Boolean(huidig);

    this.classList.toggle("is-panel-open", diep);
    if (this.back) this.back.hidden = !diep;
    if (this.flag) this.flag.hidden = diep;

    if (!this.titleEl) return;
    const panel = huidig ? this.panels.get(huidig.id) : null;
    if (panel) {
      this.titleEl.textContent = panel.dataset.title || "";
      this.titleEl.href = panel.dataset.url || "#";
      this.titleEl.hidden = false;
    } else {
      this.titleEl.hidden = true;
      this.titleEl.textContent = "";
      this.titleEl.removeAttribute("href");
    }
  }

  scrollTop() {
    const scroller = this.closest(".mobile-menu-drawer--inner") || this.parentElement;
    if (scroller && typeof scroller.scrollTo === "function") scroller.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }

  /* Sluit je het hamburgermenu, dan begin je de volgende keer weer bovenaan. */
  reset() {
    while (this.stack.length) this.goBack();
  }
}

customElements.define("mobile-menu", MobileMenu);
